import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { removeElement } from "../../utils/array";
export const PointerButton = {
    Unknown: -2,
    None: -1,
    Left: 0,
    Middle: 1,
    Right: 2
};
export const PointerButtonFlags = {
    None: 0,
    Left: 1,
    Right: 2,
    Middle: 4,
};
export class PointerInfo {
    constructor(pEvent) {
        this.event = pEvent;
        this.id = pEvent.pointerId;
        this.type = pEvent.pointerType;
        this.position = new Vector2(pEvent.clientX, pEvent.clientY);
        this.initialPosition = this.position.clone();
        this.previousPosition = this.position.clone();
        this.isMousePointer = PointerInfo.IsMousePointer(pEvent);
        this.button = pEvent.button == null ? PointerButton.Unknown : pEvent.button;
        this.initialButton = this.button;
        this.previousButton = this.button;
        this.buttons = pEvent.buttons == null ? PointerButtonFlags.None : pEvent.buttons;
        this.previousButtons = this.buttons;
    }
    update(pEvent) {
        this.previousPosition.copyFrom(this.position);
        this.position.copyFromFloats(pEvent.clientX, pEvent.clientY);
        this.previousButton = this.button;
        this.button = pEvent.button == null ? PointerButton.Unknown : pEvent.button;
        this.previousButtons = this.buttons;
        this.buttons = pEvent.buttons == null ? PointerButtonFlags.None : pEvent.buttons;
    }
    static IsMousePointer(pEvent) {
        return (pEvent != null && pEvent.pointerType === "mouse");
    }
    static IsPrimaryMousePointer(pEvent) {
        return (PointerInfo.IsMousePointer(pEvent) && pEvent.button === PointerButton.Left);
    }
}
export class InputState {
    constructor() {
        this.reset();
        this.pointerPosition = new Vector2(0, 0);
        this.pointerType = "";
    }
    reset() {
        this.pointers = new Map();
        this.mPointerIds = new Array();
    }
    registerPointer(pEvent) {
        if (this.setOrUpdatePointer(pEvent, false)) {
            this.mPointerIds.push(pEvent.pointerId);
            return (true);
        }
        return (false);
    }
    updatePointer(pEvent) {
        return (this.setOrUpdatePointer(pEvent, true));
    }
    deregisterPointer(pPointerId) {
        if (this.pointers.has(pPointerId)) {
            this.pointers.delete(pPointerId);
            removeElement(this.mPointerIds, pPointerId);
            return (true);
        }
        return (false);
    }
    getPointer(pPointerId) {
        const tPointer = this.pointers.get(pPointerId);
        return (tPointer == null ? null : tPointer);
    }
    getPointerByIndex(pIndex) {
        if (pIndex == null || pIndex < 0 || pIndex > this.mPointerIds.length - 1)
            return (null);
        const tPointer = this.pointers.get(this.mPointerIds[pIndex]);
        return (tPointer == null ? null : tPointer);
    }
    /**
     * Returns true if the pointerId of the given event belongs to the currently only
     * active pointer and in case of a mouse device it has to be the left mouse button.
     */
    isPrimaryPointer(pEvent) {
        if (pEvent == null || this.pointers.size !== 1)
            return (false);
        const tPointer = this.pointers.get(pEvent.pointerId);
        return (tPointer != null &&
            (!tPointer.isMousePointer || tPointer.initialButton === PointerButton.Left));
    }
    /**
     * Returns true if there is currently no active pointer and the event belongs to a mouse device.
     */
    isMouseHoverPointer(pEvent) {
        return (this.pointers.size === 0 && PointerInfo.IsMousePointer(pEvent));
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _updatePointerPosition(pEvent) {
        if (pEvent != null) {
            this.pointerPosition.copyFromFloats(pEvent.clientX, pEvent.clientY);
            const tPointerEvent = pEvent;
            if (tPointerEvent.pointerType != null &&
                pEvent.type !== "pointerup") //workaround, sometimes the pointerType is "mouse" even on touch devices
             {
                this.pointerType = tPointerEvent.pointerType;
            }
        }
    }
    setOrUpdatePointer(pEvent, pUpdate) {
        this._updatePointerPosition(pEvent);
        if (pUpdate) {
            if (this.pointers.has(pEvent.pointerId)) {
                this.pointers.get(pEvent.pointerId).update(pEvent);
                return (true);
            }
        }
        else {
            if (!this.pointers.has(pEvent.pointerId)) {
                this.pointers.set(pEvent.pointerId, new PointerInfo(pEvent));
                return (true);
            }
        }
        return (false);
    }
}
